export function stickyTab() {
    if ($('#sticky-tab').length == 0) return false;
    var element_to_stick = $('#sticky-tab');
    var heightTabnavi = element_to_stick.children('div').children('ul').outerHeight();
    var widthTabnavi = element_to_stick.children('div').children('ul').outerWidth();
    var window_top = $(window).scrollTop();
    var top_position = element_to_stick.offset().top;
    if (window_top > top_position) {
        if (!element_to_stick.hasClass('sticky')) {
            element_to_stick.addClass('sticky');
          //  $('#scrolltop_button').addClass('sticky');
            element_to_stick.css('padding-top', heightTabnavi);
            element_to_stick.children('div').children('ul').css('width', widthTabnavi);
        }

        var window_top_with_navi = window_top + heightTabnavi + 2;

        element_to_stick.children('div').children('ul').children('li').each(function () {
            var thisTab = $(this);
            var curHref = $(this).children('a').attr('href');
            var offsetTopCurHref = $(curHref).offset().top;
            var offsetBottomCurHref = $(curHref).offset().top + $(curHref).outerHeight();
            if ((window_top_with_navi > offsetTopCurHref) && (window_top_with_navi < offsetBottomCurHref)) {
                thisTab.prevAll().removeClass('tabon').addClass('taboff');
                thisTab.nextAll().removeClass('tabon').addClass('taboff');
                thisTab.removeClass('taboff').addClass('tabon');
            }
        })
    } else {
        if (element_to_stick.hasClass('sticky')) {
            element_to_stick.removeClass('sticky');
           // $('#scrolltop_button').removeClass('sticky');
            element_to_stick.css('padding-top', '');
            element_to_stick.children('div').children('ul').css('width', '');
        }
    }
}
